import { Divider, Skeleton, Stack } from '@mui/material';
import React from 'react';
import './header.scss';
import packageJson from '../../../package.json';
import appSettings from '../../appSettings';
import logo from '../../images/alaska-logo.png';
import { useAuth } from '../context/AuthContext/AuthContext';
import { motion } from 'framer-motion';

const Header: React.FC = () => {
  const { userData, isLoading } = useAuth();
  return (
    <nav>
      <Stack
        className="navbar"
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        flexWrap="wrap"
      >
        <Stack
          direction="row"
          alignItems="center"
          spacing={2}
          divider={
            <Divider className="name-divider" orientation="vertical" flexItem />
          }
        >
          <img height={70} src={logo} alt="Alaska Logo Loading..." />

          {/* When user Data is loadingshow the skeleton oterwise show the user name */}
          {isLoading || !userData ? (
            <Skeleton
              variant="rectangular"
              width="10rem"
              height={20}
              sx={{ borderRadius: '0.5rem' }}
              data-testid="username-skeleton"
            />
          ) : (
            <motion.p
              initial={{ x: '100px', opacity: 0 }}
              animate={{ x: 0, opacity: 1 }}
              transition={{ type: 'spring', stiffness: 55, duration: 0.5 }}
            >
              Welcome {userData?.profile?.name}
            </motion.p>
          )}
        </Stack>
        <Stack
          direction="row"
          divider={
            <Divider className="divider" orientation="vertical" flexItem />
          }
          spacing={1}
        >
          <p>v{packageJson.version}</p>
          <p>{appSettings.ENV} Environment</p>
        </Stack>
      </Stack>
    </nav>
  );
};

export default Header;
